import styled from 'styled-components'
import { Card } from 'react-bootstrap'

export const ViewContainer = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: transparent;
`

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: transparent;
`

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 1.25rem;

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const HeaderSection = styled.div`
  background-color: transparent;
  padding: 12px 24px 0;

  @media (max-width: 768px) {
    padding: 8px 16px 0;
  }
`

export const StepCard = styled(Card)`
  background: transparent;
  border: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 0;
  border-radius: 8px;
`

export const StepHeader = styled.div<{ $gradient: string }>`
  background: ${(props) => props.$gradient};
  padding: 1.25rem 1.5rem;
  border-radius: 8px 8px 0 0;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 1rem 1.25rem;
  }
`

export const StepContent = styled.div`
  background: transparent;
  padding: 0;
  border-radius: 0 0 8px 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  .scrollable-content {
    flex: 1;
    overflow-y: auto;
    padding: 1.5rem;
    padding-bottom: 3rem;
    min-height: 0;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
      padding: 1.25rem;
      padding-bottom: 3rem;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
      background: #4a4a4a;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #5a5a5a;
    }
  }

  .upload-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
    padding: 2rem 0;
  }

  .upload-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .upload-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const PageHeader = styled(Card)`
  margin-bottom: 1.5rem;
  background: transparent !important;
  border: none !important;
  padding: 24px 24px 0;

  .card-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: transparent;
    padding: 0;
  }

  .subtitle {
    color: #8c8c8c;
    font-size: 0.7rem;
    margin-top: 0.25rem;
  }

  @media (max-width: 768px) {
    padding: 16px 16px 0;
  }
`

export const MetricsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 8px 24px 24px;

  @media (max-width: 768px) {
    padding: 8px 16px 16px;
  }
`

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  grid-auto-rows: 1fr;

  ${StepCard} {
    margin-bottom: 0;
    height: 100%;
    min-height: 180px;
  }
`
